import React, { useState } from "react";

import { IconDownload, IconSendEmail } from "../../../../common/icons/index";

const columns = [
  "Customer",
  "0-30 Days",
  "30-60 Days",
  "60-90 Days",
  "90-120 Days",
  "120+ Days",
];

const tableData = [];
for (let i = 0; i < 20; i++) {
  tableData.push({
    id: i,
    customer: "Zotoware",
    first: 435 + ( 10 * i),
    second: 3  + ( 10 * i),
    third: 19 + ( 10 * i),
    fourth: 14 + ( 10 * i),
  });
}

const options = [
  { value: "jessica.hanson@example.com", label: "jessica.hanson@example.com" },
  { value: "john.doe@example.com", label: "john.doe@example.com" },
  { value: "alex@example.com", label: "alex@example.com" },
];

const StaticTableContent = () => {
  return (
    <React.Fragment>
      <h3 className="font-20">{tableData.length} Reports</h3>
      <div
        className="table-responsive"
        style={{ height: "calc(100vh - 350px)" }}
      >
        <table className="table table-card table-card--ls">
          <thead>
            <tr>
              {columns.map((column) => {
                return (
                  <th scope="col" key={column}>
                    {column}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {tableData.map((tdata) => {
              return (
                <tr key={tdata.id}>
                  <td>{tdata.customer}</td>
                  <td>${tdata.first}</td>
                  <td>${tdata.second}</td>
                  <td>${tdata.third}</td>
                  <td>${tdata.fourth}</td>
                  <td>${tdata.first + tdata.second + tdata.third + tdata.fourth }</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  );
};

export default StaticTableContent;
